import { refreshToken } from '@convergence/client';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { API_ENDPOINT } from '../../lib/api';
import { useCheckoutSession } from './useCheckoutSession';

export function CheckoutReturn() {
  const [searchParams] = useSearchParams();

  const sessionId = searchParams.get('session_id');
  const session = useCheckoutSession(sessionId);

  const { isSuccess } = useQuery({
    queryKey: ['refresh'],
    queryFn: async () => {
      console.log('query');
      await refreshToken(`${API_ENDPOINT}/auth/token/refresh`); // user will have new roles that need to be fetched
      return true;
    }
  });

  useEffect(() => {
    if (isSuccess && session.status === 'success') {
      window.location.href = '/';
    }
  }, [isSuccess, session.status]);

  return (
    <div>
      <h1>Thank you for your order!</h1>
      <p>Status: {session.status}</p>
    </div>
  );
}
